/* istanbul ignore file */

export const CLOSE_CUSTOM_STATUS_DIALOG_EVENT = 'CLOSE_CUSTOM_STATUS_DIALOG_EVENT'
